import React, { useState } from "react"
import { interfaces } from "service/interfaces"
import BasicTable from "Components/UI/Atoms/BasicTable"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"

import { IconButton, TablePagination } from "@material-ui/core"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"
import InputsWithoutValidate from "Components/UI/Molecules/InputsWithoutValidate"
import { Content } from "./Content"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import { Delete } from "@material-ui/icons"

const Add = ({ data, render, setRender, handleClose, open }) => {
  const [isLoading, setIsLoading] = useState(false) 
  const [formEdit, setFormEdit] = useState([])

  const [currentPage, setCurrentPage] = useState(0)
  const [ count, setCount ] = useState(0)
  

  const [info, setInfo] = useState({
    search: "", 
    usuario_controlador: null, 
  }) 

  const createDismissableSnackbar = useCustomSnackbar()

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo, 
      [name]: value, 
    }))
  }

  async function handleSubmitCode(info) {
    setIsLoading(true)
    const search = { search : info.search}
    await interfaces.wafersWithControlInterface
      .search(search)
      .then((res) => {
        const exists = formEdit.some(item => item.id === res.data.id)
        if (exists) {
          createDismissableSnackbar("El vehículo ya fue agregado", { variant: "warning" })
        } else {
          setFormEdit((prevFormEdit) => [...prevFormEdit, res.data])
        }
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: "error",
        })
      })
    setIsLoading(false)
  }
  
  function _renderStepContent() {
        return (
          <InputsWithoutValidate
            fields={Content(
              info,
              handleSubmitCode,
              handleChange,
              isLoading,
              data,
              setCurrentPage,
              setCount
            )}
            spacing={2}
          />
        )  
  }

  const create = async () => {
    const body = {
      usuario_controlador_id: info.usuario_controlador,
      vehiculos: formEdit.map((item) => ({
        vehiculo_id: item.id
      }))
    }
    setIsLoading(true)
    await interfaces.wafersWithControlInterface
      .create(body)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        handleClose()
        setRender(!render)
      })
      .catch(() => {
        createDismissableSnackbar("Error", {
          variant: "error",
        })
      })
    handleClose()
    setIsLoading(false)
  }

  function disabledSubmit() {
    return !info.usuario_controlador || formEdit.length === 0
  }

  const handleDelete = (id) => {
    setFormEdit((prevFormEdit) => prevFormEdit.filter((item) => item.id !== id))
  }

  const iconDelete = (id) => {
    return (
      <IconButton
        onClick={() => handleDelete(id)}
        style={{padding: "0px"}}
      >
        <Delete />
      </IconButton>
    )
  }

  return (
    <DialogComponent
      paddingReduce={true}
      tipo="center"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      disableBackdropClick={isLoading}
      disableEscapeKeyDown={isLoading}
      title="Seleccionar vehículos a controlar"
      widthLarge={"1000px"}
      customHeight={"1000px"}
      children={
        <>
          <div style={{margin: '10px 0 10px 0'}}> 
            {_renderStepContent()}
          </div>

          <>
            <BasicTable
              col={[
                { title: "Dominio", style: { width: "80px" } },
                { title: "Marca", style: { width: "80px" } },
                { title: "Modelo", style: { width: "80px" } },
                { title: "Año", style: { width: "80px" } },
                { title: "", style: { width: "40px" } },
              ]}
              size={"small"}
              rows={formEdit.map((row) => {
                return {
                  dominio: row.dominio,
                  marca: row.marca,
                  modelo: row.modelo,
                  año: row.año,
                  action: iconDelete(row.id),
                }
              })}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", position: "sticky", bottom: "0", backgroundColor: "white", zIndex: "10"}} >
              <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={count}
                rowsPerPage={25}
                page={currentPage}
              // onPageChange={handleChangePage}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              />       
            </div>   
          </>
        
        </>
      }
      actions={
        <CancelConfirmButtons
          disabledSubmit={isLoading ? true : disabledSubmit()}
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={create}
          onClickCancel={handleClose}
        />
      }
    />
  )
}

export default Add
